export enum BookingDayStatus {
    UNKNOWN,
    ACTIVE,
    INACTIVE,
    SELECTED
}